<template>
    <div>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="'委托书更新'" :name="'jciName'" :value="'jciName'" :tabslist="tabForm">
                        <template slot="tabs">
                            <div class="table_content_box">
                                <!-- 主信息 -->
                                <el-form id="mainInfo" label-width="140px" label-position="right" size="mini" ref="sendDataInfo" class="baseForm" :model="sendDataInfo" :show-message="false">
                                    <el-tag size="mini" style="margin-bottom: 10px;">申请信息</el-tag>
                                    <el-row>
                                        <el-form-item label="申请部门" prop="cmCode">
                                            <label slot="label" :style="$common.labelStyle('申请部门')" v-html="$common.htmlLabel('申请部门')"></label>
                                            <el-input disabled v-model="sendDataInfo.depName"></el-input>
                                        </el-form-item>
                                        <el-form-item label="申请人" prop="cmCode">
                                            <label slot="label" :style="$common.labelStyle('申请人')" v-html="$common.htmlLabel('申请人')"></label>
                                            <el-input clearable disabled v-model="sendDataInfo.opmName"></el-input>
                                        </el-form-item>
                                        <el-form-item label="申请原因" prop="applyReason" :rules="[{ required: true, trigger: ['blur', 'change'] },]">
                                            <label slot="label" :style="$common.labelStyle('申请原因')" v-html="$common.htmlLabel('申请原因')"></label>
                                            <el-input clearable type="textarea" :rows="2" v-model="sendDataInfo.applyReason"></el-input>
                                        </el-form-item>
                                        <el-form-item label="修改备注" prop="remark">
                                            <label slot="label" :style="$common.labelStyle('修改备注')" v-html="$common.htmlLabel('修改备注')"></label>
                                            <el-input clearable type="textarea" rows="2" v-model="sendDataInfo.remark"></el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-tag size="mini" style="margin-bottom: 10px;">基础信息</el-tag>
                                    <el-row>
                                        <el-form-item label="业务员类型" prop="salesmanType" :rules="[{ required: true, trigger: ['blur', 'change'] },]">
                                            <label slot="label" :style="$common.labelStyle('业务员类型')" v-html="$common.htmlLabel('业务员类型')"></label>
                                            <el-select size="mini" disabled v-model="sendDataInfo.salesmanType" placeholder="请选择">
                                                <el-option v-for="item in salesmanTypeList" :key="item.key" :label="item.value" :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="单位名称" prop="unitName" :rules="[{ required: true, trigger: ['blur', 'change'] },]">
                                            <label slot="label" :style="$common.labelStyle('单位名称')" v-html="$common.htmlLabel('单位名称')"></label>
                                            <el-input @clear="clearClick('unitName,unitId,fileNumber')" clearable :disabled="dataActionBox.actionType == 1" v-model="sendDataInfo.unitName"
                                                      @keyup.enter.native="openSearch(157783642640384, 0, 'unitName', 'unitName,unitId,fileNumber')">
                                                <el-button @click="openSearch(157783642640384, 0, 'unitName', 'unitName,unitId,fileNumber')" slot="append" icon="el-icon-search">
                                                </el-button>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="档案编号" prop="fileNumber">
                                            <label slot="label" :style="$common.labelStyle('档案编号')" v-html="$common.htmlLabel('档案编号')"></label>
                                            <el-input clearable disabled v-model="sendDataInfo.fileNumber"></el-input>
                                        </el-form-item>
                                    </el-row>
                                </el-form>
                            </div>
                            <div>
                                <el-row id="operateBtn">
                                    <el-button type="primary" size="mini" @click="addDetails">新增</el-button>
                                    <el-button type="danger" size="mini" @click="delDetails">删除</el-button>
                                </el-row>
                                <el-table :data="sendDataInfo.cuslicencelinfos" ref="mxTableRef" id="mxTable" :height="mxHeight" border style="width: 100%" size="mini">
                                    <el-table-column label="选择操作" width="90">
                                        <template slot-scope="scope">
                                            <el-radio v-model="selectDetailsIndex" :label="scope.$index" border size="mini">
                                                <i class="el-icon-thumb"></i>
                                            </el-radio>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="业务员名称" prop="salesName" min-width="150">
                                        <template slot-scope="scope">
                                            <el-input clearable v-model="scope.row.salesName" @input="inpputChange('salesName', scope.$index)" placeholder="业务员名称"></el-input>
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column label="助记码" prop="salesMne" min-width="150"></el-table-column> -->
                                    <el-table-column label="地域限制" prop="geogRest" min-width="80">
                                        <template slot-scope="scope">
                                            <el-select v-model="scope.row.geogRest" style="width: 100%;" clearable>
                                                <el-option v-for="item in geogRestData" :key="item.diId" :label="item.diName" :value="item.diValue">
                                                </el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="性别" prop="salesSex" min-width="70">
                                        <template slot-scope="scope">
                                            <el-select v-model="scope.row.salesSex" style="width: 100%;" clearable>
                                                <el-option v-for="(val, key) in sexData" :key="key" :label="val.diName" :value="val.diValue"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="电话" prop="phone" min-width="120">
                                        <template slot-scope="scope">
                                            <el-input clearable type="text" @input="inpputChange('phone', scope.$index)" v-model="scope.row.phone" placeholder="输入电话"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="身份证号" prop="salesNumber" min-width="230">
                                        <template slot-scope="scope">
                                            <el-input class="SFZ" @input="inpputChange('salesNumber', scope.$index)" clearable v-model="scope.row.salesNumber" placeholder="输入身份证号">
                                                <template slot="append"><span style="color: red;">{{ String(scope.row.salesNumber).length
                                          }}位</span></template>
                                            </el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="身份证有效期" prop="numberValidity" min-width="180">
                                        <template slot-scope="scope">
                                            <df-date v-model="scope.row.numberValidity" @input="inpputChange('numberValidity', scope.$index)" class="dfDate"></df-date>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="备注" prop="remark" min-width="150">
                                        <template slot-scope="scope">
                                            <el-input clearable v-model="scope.row.remark" placeholder="输入备注"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="委托书类型" prop="terType" min-width="90">
                                        <template slot-scope="scope">
                                            <el-select v-model="scope.row.terType" style="width: 100%;" clearable>
                                                <el-option label="全品委托" :value="0"></el-option>
                                                <el-option label="单品委托" :value="1"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="委托书名称" prop="terName" min-width="200">
                                        <template slot-scope="scope">
                                            <el-select v-model="scope.row.terName" style="width: 100%;" clearable>
                                                <el-option v-for="(values) in dictionariesDatas" :key="values.diId" :label="values.diName" :value="values.diValue"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="委托书有效期" prop="terValidity" min-width="180">
                                        <template slot-scope="scope">
                                            <df-date v-model="scope.row.terValidity" class="dfDate"></df-date>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="委托范围" prop="terScope" min-width="200">
                                        <template slot-scope="scope">
                                            <el-select v-model="scope.row.terScope" style="width: 100%;" clearable>
                                                <el-option label="全部" :value="0"></el-option>
                                                <el-option label="药品" :value="1"></el-option>
                                                <el-option label="器械" :value="2"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="委托书附件" prop="filePath" min-width="200" fixed="right">
                                        <template slot-scope="scope">
                                            <ul class="uploadList" v-if="scope.row.filePath">
                                                <li v-for="(val, key) in scope.row.filePath.split(',')" :key="key" class="image">
                                                    <i class="el-icon-error del" @click="delRemove(scope.$index, key)"></i>
                                                    <cusImage style="width: 30px; height: 30px;margin-top: 5px;" :src="imgUrl + '/' + val"
                                                              :preview-src-list="scope.row.filePath.split(',').map(item => `${imgUrl}/${item}`)">
                                                    </cusImage>
                                                </li>
                                            </ul>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" prop="" :width="printScanShow?330:250" fixed="right">
                                        <template slot-scope="scope">
                                            <input style="display: none;" type="file" id="recordExcel" accept="image/*" multiple name="recordExcel"
                                                   @change="(e) => { fileUpload(e.target.files, e.target.files.length, 0, e) }" />
                                            <label for="recordExcel" class="image_label" @click="selectDetailsIndex = scope.$index">点击上传</label>
                                            <el-button type="primary" @click="showUploadDialog(scope.$index)">拖拽上传</el-button>
                                            <el-button @click.stop="openFile1(0), selectDetailsIndex = scope.$index" type="primary" size="mini">高拍仪</el-button>
                                            <el-button v-if="printScanShow" @click.stop="openFile1(1), selectDetailsIndex = scope.$index" type="primary" size="mini">扫描仪</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foot">
                    <el-button type="primary" @click="initActionBox">取消</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')">保存
                    </el-button>
                </div>
            </div>
        </div>
        <!-- 检索方案 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" top="10px">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <ImageViewer v-if="showImgViewer" :url-list="imgPreviewUrl" :on-close="() => { showImgViewer = false; }" :z-index="3000" />
        <FileNewAction ref="FileNewAction" v-if="showFile" @isshowFile="IsshowFile" :showFile="showFile" @NewelectFileIds="changeInputModelgps"></FileNewAction>
        <DragUpload ref="dragUpload" title="文件上传" :multiple="true" :limit="100" @confirm="onUploadConfirm" />
        <!-- 扫描仪 -->
        <el-dialog title="扫描仪上传" destroy-on-close :visible.sync="scanShow" width="80%" append-to-body top="20px">
            <scannerPlugin v-if="scanShow" ref="scannerPlugin" @submit="scanOnSubmit"></scannerPlugin>
        </el-dialog>
    </div>
</template>

<script>
import SearchScheme from "@/byComponents/SearchScheme.vue";
import ImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
    name: "powerOfAttorney",
    props: ['actionData'],
    components: {
        SearchScheme,
        ImageViewer
    },
    data() {
        return {
            salesType: true,//判断修改同名称业务员的身份证号、电话、身份证有效期是否同名称变更
            mxHeight: 0,
            token: {
                token: sessionStorage.getItem("token")
            },
            dataActionBox: {
                actionType: 0,
            },
            tabForm: [{
                jurId: "1",
                jurconfigform: [{

                }],
                jciName: "委托书更新"
            }],
            sendDataInfo: {
                gchmType: 3,
                opmId: "",
                depId: "",
                depName: "",
                opmName: "",
                applyReason: "",
                remark: "",
                unitId: "",
                unitName: "",
                salesmanType: "",
                fileNumber: "",
                cuslicencelinfos: [],
                cuslicencelinfos1: [],
            },
            detailsObj: {
                salesName: "",
                salesMne: "",
                salesSex: "",
                phone: "",
                salesNumber: "",
                numberValidity: "",
                remark: "",
                terName: "",
                terType: "",
                terValidity: "",
                isUsed: 1,
                isIntercept: 0,
                filePath: "",
                geogRest: "",
                terType: 0,
                terScope: 0,
            },
            salesmanTypeList: [//业务员列表
                {
                    key: 0,
                    value: "客户",
                },
                {
                    key: 1,
                    value: "供应商",
                },
            ],
            geogRestData: [],//限制地域列表
            sexData: [],//性别列表
            dictionariesDatas: [],//证照类型列表
            selectDetailsIndex: 0,
            requesUrl: "",
            imgUrl: "",
            showImgViewer: false,//是否打开图片预览
            imgPreviewUrl: "",//图片预览
            showFile: false,
            //-----------------------------
            seTitle: "", //检索
            seWidth: 0,
            seIndex: 0,
            seType: 0,
            sField: 0,
            seId: 0,
            DialogVisible: false,
            parentSearchData: {},
            //---------扫描仪上传
            scanShow: false,
            printScanShow: false,
        }
    },
    watch: {
        // "sendDataInfo.salesmanType": {
        //     handler(newVal, oldVal) {
        //         if (newVal != oldVal) {
        //             this.sendDataInfo.fileNumber = ""
        //             this.sendDataInfo.unitId = ""
        //             this.sendDataInfo.unitName = ""
        //         }
        //     },
        //     deep: true
        // },
    },
    created() {
        this.openBoxS()
    },
    methods: {
        clearClick(val) {
            var arr = val.split(',')
            arr.forEach(item => {
                this.$set(this.sendDataInfo, item, "")
            })
            if (arr.indexOf('unitId') !== -1 || arr.indexOf('unitName') !== -1) {
                this.sendDataInfo.cuslicencelinfos = []
                this.sendDataInfo.cuslicencelinfos1 = []
            }
        },
        // 新增明细行模板（不含 scsId / salesId 等主键）
        getEmptyDetailRow() {
            const row = {
                salesName: "",
                salesMne: "",
                salesSex: "",
                phone: "",
                salesNumber: "",
                numberValidity: "",
                remark: "",
                terName: "",
                terType: 0,
                terValidity: "",
                isUsed: 1,
                isIntercept: 0,
                filePath: "",
                geogRest: "",
                terScope: 0,
                _isNew: true,
            }
            return JSON.parse(JSON.stringify(row))
        },
        stripNewRowIds(item) {
            if (item._isNew) {
                delete item.scsId
                delete item.salesId
                delete item.id
                delete item._isNew
            }
        },
        showUploadDialog(index) {
            this.eventIndex = index
            this.$refs.dragUpload.open();
        },
        onUploadConfirm(files) {
            console.log('上传的文件:', files);
            files.forEach(item => {
                var list = []
                if (this.sendDataInfo.cuslicencelinfos[this.selectDetailsIndex].filePath) {
                    list = this.sendDataInfo.cuslicencelinfos[this.selectDetailsIndex].filePath.split(',')
                }
                list.push(item.fileUrl)
                this.sendDataInfo.cuslicencelinfos[this.selectDetailsIndex].filePath = list.join()
            })
        },
        inpputChange(type, index) {
            console.log(this.salesType);
            var info = this.sendDataInfo.cuslicencelinfos[index]
            if (this.salesType) {
                var arr = this.sendDataInfo.cuslicencelinfos.filter(item => item.salesId && info.salesId && item.salesId == info.salesId)
                if (arr.length > 0) {
                    arr.forEach(item => {
                        if (type == 'salesName') {
                            this.$set(item, type, info[type])
                            if (item[type] != "" && item[type] != null) {
                                item.salesMne = this.$common.createPinyinCode(item[type])
                            }
                        } else {
                            this.$set(item, type, info[type])
                        }
                    })
                }
            } else {
                if (type == 'salesName') {
                    info.salesMne = this.$common.createPinyinCode(info[type])
                }
            }
        },
        changeInputModelgps(val) {
            var list = []
            if (this.sendDataInfo.cuslicencelinfos[this.selectDetailsIndex].filePath) {
                list = this.sendDataInfo.cuslicencelinfos[this.selectDetailsIndex].filePath.split(',')
            }
            if (val.length > 0) {
                val.forEach(item => {
                    list.push(item.fileUrl)
                })
            }
            this.sendDataInfo.cuslicencelinfos[this.selectDetailsIndex].filePath = list.join()
            this.showFile = false;
        },
        IsshowFile(value) {
            this.showFile = value;
            console.log(this.showFile);
        },
        //  打开文件上传组件
        openFile1(val) {
            if (val == 1) {
                this.scanShow = true
            } else {
                this.showFile = true
            }
        },
        // 扫描仪上传
        scanOnSubmit(val) {
            var list = []
            if (this.sendDataInfo.cuslicencelinfos[this.selectDetailsIndex].filePath) {
                list = this.sendDataInfo.cuslicencelinfos[this.selectDetailsIndex].filePath.split(',')
            }
            if (val.length > 0) {
                val.forEach(item => {
                    list.push(item.fileUrl)
                })
            }
            this.sendDataInfo.cuslicencelinfos[this.selectDetailsIndex].filePath = list.join()
            this.scanShow = false
        },
        delRemove(index, key) {
            this.selectDetailsIndex = index
            var arr = this.sendDataInfo.cuslicencelinfos[this.selectDetailsIndex].filePath.split(",")
            arr.splice(key, 1)
            console.log(arr);
            this.sendDataInfo.cuslicencelinfos[this.selectDetailsIndex].filePath = arr.join()
        },
        async fileUpload(files, length, index, e) {
            if (length - 1 >= index) {
                console.log(files[index]);
                const params = {
                    file: files[index]
                }
                const response = await this.$http.uploadFile(params, true)
                if (response.status == 200) {
                    var list = []
                    if (this.sendDataInfo.cuslicencelinfos[this.selectDetailsIndex].filePath) {
                        list = this.sendDataInfo.cuslicencelinfos[this.selectDetailsIndex].filePath.split(',')
                    }
                    list.push(response.result[0].fileUrl)
                    this.sendDataInfo.cuslicencelinfos[this.selectDetailsIndex].filePath = list.join()
                    this.fileUpload(files, length, index + 1, e)
                } else {
                    e.target.value = ""
                    this.$message.error(response.message)
                }
            } else {
                e.target.value = ""
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        openSearch(sId, index, type, sField) {
            console.log(this.sendDataInfo.salesmanType);

            if (this.sendDataInfo.salesmanType !== 0 && this.sendDataInfo.salesmanType != 1) {
                return this.$message({
                    message: "请先选择业务员类型",
                    type: "warning",
                });
            }
            this.seIndex = index;
            this.seType = type;
            this.sField = sField
            this.seId = this.sendDataInfo.salesmanType == 1 ? 155784192757760 : 157783642640384//	业务员类型0 客户 1供应商
            this.DialogVisible = true;
            if (type == 'unitName') {
                if (this.sendDataInfo.salesmanType === 1) {
                    this.parentSearchData['smName'] = this.sendDataInfo['unitName']
                } else {
                    this.parentSearchData['cmName'] = this.sendDataInfo['unitName']
                }
            } else {
                this.parentSearchData[type] = this.sendDataInfo[type]
            }
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                if (this.seType == 'unitName') {
                    if (this.sendDataInfo.salesmanType == 1) {
                        this.sendDataInfo.unitId = val.smId;
                        this.sendDataInfo.unitName = val.smName;
                        this.sendDataInfo.fileNumber = val.fileNumber;
                    } else {
                        this.sendDataInfo.unitId = val.cmId;
                        this.sendDataInfo.unitName = val.cmName;
                        this.sendDataInfo.fileNumber = val.fileNumber;
                    }
                    if (this.dataActionBox.actionType === 0) {
                        this.queryDetails()
                    }
                } else {
                    this.paramValue(val)
                }
                this.DialogVisible = false;
            } else {
                this.DialogVisible = false;
                this.$message({
                    message: "检索失败",
                    type: "error",
                });
            }
        },
        async queryDetails() {
            this.sendDataInfo.cuslicencelinfos = []
            this.sendDataInfo.cuslicencelinfos1 = []
            const responseData = await this.$http.gspChangequeryDeAuthLetter({ ids: [this.sendDataInfo.unitId] })
            if (responseData.status == 200) {
                const list = responseData.result || []
                this.sendDataInfo.cuslicencelinfos = JSON.parse(JSON.stringify(list))
                this.sendDataInfo.cuslicencelinfos1 = JSON.parse(JSON.stringify(this.sendDataInfo.cuslicencelinfos))
            }
        },
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.$set(this.sendDataInfo, item, val[item])
            })
        },
        addDetails() {//sendDataInfo
            this.$refs['sendDataInfo'].validate((valid) => {
                if (valid) {
                    if (this.sendDataInfo.cuslicencelinfos.length > 0) {
                        var flag = false
                        this.sendDataInfo.cuslicencelinfos.forEach((item, index) => {
                            if (item.salesName == "" || item.terName == "" || item.geogRest == "" && !flag) {
                                flag = true
                                this.selectDetailsIndex = index
                            }
                        })
                        if (flag) {
                            return this.$message.error("业务员名称、委托书名称、地域限制不能为空")
                        }
                    }
                    this.sendDataInfo.cuslicencelinfos.push(this.getEmptyDetailRow())
                    this.selectDetailsIndex = this.sendDataInfo.cuslicencelinfos.length - 1
                } else {
                    this.$message.error("请完善主信息!")
                    return false;
                }
            });

        },
        async delDetails() {
            const row = this.sendDataInfo.cuslicencelinfos[this.selectDetailsIndex]
            if (row.scsId && !row._isNew) {
                const params = {
                    ids: [row.scsId]
                }
                const res = await this.$http.counterpartySalesmandeleteState(params)
                if (res.status == 200) {
                    this.sendDataInfo.cuslicencelinfos.splice(this.selectDetailsIndex, 1)
                } else {
                    this.$message.error(res.message)
                }
            } else {
                this.sendDataInfo.cuslicencelinfos.splice(this.selectDetailsIndex, 1)

            }

        },
        //取消新增
        initActionBox() {
            this.$emit("drawerCancel");
        },
        sendDataAction() {
            this.$refs['sendDataInfo'].validate((valid) => {
                if (valid) {
                    this.sub()
                } else {
                    this.$message.error("请完善主信息!")
                    return false;
                }
            });
        },
        async sub() {
            var sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
            if (JSON.stringify(sendData.cuslicencelinfos1) == JSON.stringify(sendData.cuslicencelinfos) && this.dataActionBox.actionType === 0) {
                return this.$message.error("委托书数据未更改")
            }
            this.sendDataInfo.cuslicencelinfos.forEach(item => {
                this.$set(item, 'salesmanType', this.sendDataInfo.salesmanType)
                this.$set(item, 'unitId', this.sendDataInfo.unitId)
                this.$set(item, 'unitName', this.sendDataInfo.unitName)
            })
            const descibAuthLetterChanges = JSON.parse(JSON.stringify(this.sendDataInfo.cuslicencelinfos))
            descibAuthLetterChanges.forEach(item => {
                item.salesmanType = this.sendDataInfo.salesmanType
                item.unitId = this.sendDataInfo.unitId
                item.unitName = this.sendDataInfo.unitName
                this.stripNewRowIds(item)
            })
            var params = {
                ...this.sendDataInfo,
                businessId: this.sendDataInfo.unitId,
                descibAuthLetterChanges
            }
            let responseData;
            if (this.dataActionBox.actionType === 0) {
                responseData = await this.$http.gspChangeaddChangeSalesPlicence(params)
            } else {
                params.gchmId = this.sendDataInfo.gchmId
                responseData = await this.$http.gspChangeupdateChangeInfo(params)
            }
            if (responseData.status == 200) {
                this.$emit("drawerCancel", true);
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取地域限制列表
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [1, 44],
            });
            if (responseData.status == 200) {
                this.sexData = responseData.result.xb;
                this.geogRestData = responseData.result.dyxz;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取委托书名称
        async getCateDictionariesDatas() {
            let responseData = await this.$http.getCateDictionariesData({
                ids: [45],
            });
            if (responseData.status == 200) {
                this.dictionariesDatas = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        openBoxS() {
            this.imgur()
            this.openBox()
            this.getPartDictionariesData()
            this.getCateDictionariesDatas()
            this.queryRule()
        },
        openBox() {
            this.printScanShow = window.global_config.printScanShow ? true : false
            this.dataActionBox.actionType = this.actionData.cate;
            var oldData = this.actionData.oldData;
            this.init();
            this.initDep()
            if (this.dataActionBox.actionType == 0) {
                this.sendDataInfo.salesmanType = this.actionData.type == "客户" ? 0 : 1;
            } else {
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    if (key == 'newauthLetterChanges') {
                        this.$set(this.sendDataInfo, 'cuslicencelinfos', dataInfo[key]);
                    } else if (key == 'chanName') {
                        this.$set(this.sendDataInfo, 'unitName', dataInfo[key]);
                    } else if (key == 'businessId') {
                        this.$set(this.sendDataInfo, 'unitId', dataInfo[key]);
                    } else {
                        this.$set(this.sendDataInfo, key, dataInfo[key]);
                    }
                }
                this.$set(this.sendDataInfo, 'gchmId', dataInfo.gchmId);
            }
            
            this.$nextTick(() => {
                setTimeout(() => {
                    this.mxHeight = this.$common.getBtnHeight();
                }, 16.7);
            });

        },
        init() {
            for (const key in this.sendDataInfo) {
                if (key == 'cuslicencelinfos' || key == 'cuslicencelinfos1') {
                    this.sendDataInfo[key] = []
                } else {
                    this.sendDataInfo[key] = ""
                }
            }
        },
        imgur() {
            // console.log(this.$store.getters.getConfig);
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        // 获取申请人员信息
        initDep() {
            let info = JSON.parse(sessionStorage.getItem("userInfo"));
            this.sendDataInfo.depName = info.depName;
            this.sendDataInfo.depId = info.depId;
            this.sendDataInfo.opmName = info.opmName;
            this.sendDataInfo.opmId = info.opmId;
            this.sendDataInfo.gchmType = 3
        },
        async queryRule() {
            let res = await this.$http.fromruleQueryRuleByName({ ids: ['委托书变更相同人员同时变更'] })
            if (res.status == 200) {
                if (!res.result) {
                    this.salesType = true
                } else if (res.result.isEnable == 1) {
                    this.salesType = true
                } else {
                    this.salesType = false
                }
            }
        }
    }
}
</script>

<style scoped>
.baseForm .el-row {
    display: flex;
    flex-wrap: wrap;
}

.btn {
    margin-bottom: 10px;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
    content: "";
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected .check {
    background-color: #409eff;
    border-color: #409eff;
}

.el-select-dropdown.is-multiple
    .el-select-dropdown__item.selected
    .check:after {
    transform: rotate(45deg) scaleY(1);
}

.el-select-dropdown.is-multiple .el-select-dropdown__item .check::after {
    box-sizing: content-box;
    content: "";
    border: 1px solid #fff;
    border-left: 0;
    border-top: 0;
    height: 7px;
    left: 4px;
    position: absolute;
    top: 1px;
    transform: rotate(45deg) scaleY(0);
    width: 3px;
    transition: transform 0.15s ease-in 0.05s;
    transform-origin: center;
}

::v-deep .upload-demo ul {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
}

::v-deep .upload-demo img {
    width: 30px;
    height: 30px;
    margin-left: 0px;
}

::v-deep .upload-demo .el-upload-list--picture .el-upload-list__item {
    width: 86px;
    height: 42px;
    padding: 5px 0px;
    padding-left: 5px;
}

::v-deep .el-upload-list__item-name {
    margin-right: 0;
    font-size: 13px;
}

::v-deep .el-upload-list__item .el-icon-close {
    top: 2px;
    right: 2px;
}

::v-deep .el-upload-list--picture .el-upload-list__item-status-label {
    width: 40px;
    height: 24px;
    right: -20px;
    top: -9px;
}

::v-deep .el-image__error {
    font-size: 13px;
}

::v-deep
    .el-upload-list--picture
    .el-upload-list__item.is-success
    .el-upload-list__item-name {
    line-height: 30px;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item .check {
    display: inline-block;
    position: relative;
    top: 2px;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    box-sizing: border-box;
    width: 14px;
    height: 14px;
    background-color: #fff;
    z-index: 1;
    transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
        background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}

/* 文本超长 */
::v-deep .el-select__tags-text {
    display: inline-block;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

::v-deep .el-select .el-tag__close.el-icon-close {
    top: -5px;
}

#cmManrange,
#cmTrerange {
    width: 100%;
    display: flex;
    padding-left: 83px;
    margin-bottom: 10px;
}

::v-deep #cmManrange .el-form-item__content,
::v-deep #cmTrerange .el-form-item__content {
    width: 100% !important;
}

::v-deep #cmManrange .el-textarea__inner,
::v-deep #cmTrerange .el-textarea__inner {
    width: 73.2% !important;
    margin-right: 20px;
    font-size: 12px;
}

.cmTitle {
    color: #606266;
    font-size: 14px;
    padding-top: 4px;
}

.cmContent {
    padding-left: 10px;
    width: 90%;
}

.cmButton {
    margin-bottom: 6px;
}

#csDia ::v-deep .el-dialog {
    min-width: 800px;
}

#cmRegaddres,
#cmWareaddress,
#cmPlace,
#cmRemark {
    width: 100% !important;
}

#cmRegaddres ::v-deep .el-form-item__content,
#cmWareaddress ::v-deep .el-form-item__content,
#cmPlace ::v-deep .el-form-item__content,
#cmRemark ::v-deep .el-form-item__content {
    width: 100% !important;
}

#cmRegaddres ::v-deep .el-textarea__inner,
#cmWareaddress ::v-deep .el-textarea__inner,
#cmPlace ::v-deep .el-textarea__inner,
#cmRemark ::v-deep .el-textarea__inner {
    width: 62% !important;
}

#cmSocialcode ::v-deep .el-form-item__content,
#cmName ::v-deep .el-form-item__content {
    width: 386px !important;
}

::v-deep .el-image-viewer__close {
    color: #fff;
}

::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-textarea.is-disabled .el-textarea__inner {
    background-color: #fff;
    color: #333;
}

::v-deep
    .el-radio-button__orig-radio:disabled:checked
    + .el-radio-button__inner {
    background-color: #ccc;
}

::v-deep .el-radio-button__orig-radio:disabled + .el-radio-button__inner {
    color: #333;
}

.baseForm ::v-deep .el-form-item__content {
    margin-left: 135px !important;
}

.baseForm ::v-deep .el-form-item__label {
    width: 135px !important;
}

.xing {
    position: absolute;
    top: 0;
    left: 5px;
    font-size: 18px;
    font-weight: 800;
}

.dfDate ::v-deep input {
    width: 150px !important;
}

.SFZ ::v-deep .el-input-group__append {
    padding: 0 5px;
}

/* 图片上传样式 */
.uploadList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 220px;
    list-style: none;
}

.image {
    position: relative;
    width: 40px;
    height: 40px;
    margin-right: 5px;
    margin-bottom: 5px;
    flex-shrink: 0;
    border: 1px solid #f3f3f3;
}

.image:nth-child(5n) {
    margin-right: 0;
}

.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.image:hover .del {
    display: inline-block;
}

.image_label {
    cursor: pointer;
    padding: 7px 10px !important;
    font-size: 12px !important;
    background-color: #409eff;
    color: #ffffff;
    line-height: 14px;
    margin-right: 5px;
    border-radius: 3px;
}

::v-deep .el-image__error {
    font-size: 7px;
}
</style>
